import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import "../../components/general.css"
import * as blogArticleStyle from "../../components/blog-article.module.css"
import Layout from "../../components/layout"
import articleImage from "../../images/blog_11.png"

const Article11 = () => {

  const [articleTitle, setArticleTitle] = React.useState("");

  React.useEffect(() => {
    const articleTitle = window.location.pathname.split('/')[2].replaceAll('-', ' ');
    setArticleTitle(articleTitle);
    console.log(articleTitle)
  }, [])

  return (
    <main>
      <Layout>
        <section className={blogArticleStyle.articleSection}>

          <div
            style={{
              background: `url(${articleImage})`,
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
            className={blogArticleStyle.headerImage}
          >
            <div>
              <span>28 JANVIER 2020  - SMARTPHONES - 3 MIN</span>
            </div>
            <div>
              <h1 className={blogArticleStyle.mainTitle}>{articleTitle}</h1>
            </div>
            <div className={blogArticleStyle.authorId}>
              <StaticImage src="../../images/mobilelabs_favicon.png" alt="favicon Mobile Lab's"></StaticImage>
              <span>Par Mobile Lab's</span>
            </div>
          </div>

          <div className={blogArticleStyle.mainContent}>

            <p>
              Actuellement en expérimentation en France, la 5G (destinée à remplacer la 4G et 3G) devrait être déployée pour tous les utilisateurs d’ici 2020 sur le territoire français.
              <br />
            </p>
            <h3>
              Débits en 5G
            </h3>
            <p>
              A l’heure actuelle, il est difficile d’établir la vitesse maximale de la 5G.
              Son déploiement a été effectué récemment sur la principauté de Monaco,
              ce qui a permis d’avoir quelques données. Xavier Niel, le fondateur de Free,
              était sur place pour les premiers tests : près de
              <a href="https://twitter.com/Xavier75/status/1148695466483343361">
                1400 Megabits/s</a> (1,4 Gigabits/s) en téléchargement ! Pour comparer,
              la 4G à un débit maximum théorique de 100 Megabits/s.
              <br />
            </p>
            <h3>Mais peut-on espérer les même débits 5G sur tout le territoires français
              ?&nbsp;
            </h3>
            <p>
              Pour l’instant, les tests se font sur des lignes qui sont loin d’être saturées.
              On peut imaginer qu’à l’avenir le débit devrait être bien différents sur le terrain.
              Par exemple le débit théorique de la 4G est de 100 Mbps mais le débit moyen sur le territoire est d’environ
              <a href="https://blog.ariase.com/mobile/actualite/debits-reels-4g">
                30 Mbps
              </a>
              . Nous pouvons donc estimer le débit moyen de la 5G à 420 Mbps,
              plusieurs années après le déploiement.
              <br />
            </p>
            <h2>
              Quels smartphones pour la 5G ?
            </h2>
            <p>
              Les constructeurs se préparent d’ores et déjà pour équiper leurs smartphones afin qu’ils soient compatibles 5G
              :&nbsp;
              <br />
            </p>
            <h4>
              <strong>Huawei Mate X</strong>
              &nbsp;
            </h4>

            <div className={blogArticleStyle.centerImage}>
              <StaticImage src="../../images/Huawei-Mate-X17-600x489.png" alt="" />
            </div>

            <p>
              Le smartphone pliable de Huawei a le droit à un vrai modem 5G. En effet le Mate X est le seul mobile qui sera équipé de la norme 5G standalone.
              Standalone, c’est la nouvelle norme qui permet au téléphone une forte augmentation de débit. Les autres smartphones 5G non standalone annoncés,
              fonctionneront avec un coeur de 4G, une sorte de 5G Lite.
              <br />
            </p>
            <h4>
              <strong>Samsung Galaxy S10 5G</strong>
            </h4>

            <div className={blogArticleStyle.centerImage}>
              <StaticImage src="../../images/s10.png" alt="" />
            </div>

            <p>
              Le déploiement de la 5G au grand public a commencé début 2019 en Corée du Sud.
              Sans surprise le géant coréen a déjà son smartphone 5G commercialisé, le premier de l’histoire.
              &nbsp;Cependant, pas de date de sortie française annoncée pour le S10 5G.
              <br />
            </p>
            <h4>
              <strong>Xiaomi Mi Mix 3 5G</strong>
            </h4>

            <div className={blogArticleStyle.centerImage}>
              <StaticImage src="../../images/Mi-Mix-3.png" alt="" />
            </div>

            <p>
              La firme chinoise Xiaomi arrive sur le marché de la 5G et comme toujours avec un smartphone d’un rapport qualité-prix exceptionnel,
              vendu en France 649,99€, il est pour le moment le smartphone 5G le moins cher du marché. Une copie du Mi Mix 3 mais proposant
              une vitesse maximale de téléchargement de 2 Gbps et une batterie boostée à 3800 mah.
            </p>
            <p>
              Encore un peu de patience pour pouvoir profité de la puissance de la 5G, mais l’ensemble&nbsp;
              paraît très prometteur. Plusieurs constructeurs manquent à l’appel : Apple, Nokia ou encore Google et devraient annoncer des nouveautés pour 2020.
              En attendant, il nous reste notre bonne veille 4G 😉
              <br />
            </p>

          </div>
        </section>
      </Layout>
    </main >
  )
}

export default Article11

export const Head = () => (
  <>
    <html lang="fr" />
    <title>Mobile Lab's BLOG  | Déploiement de la 5G en France</title>
    <meta name="description" content="Actuellement en expérimentation en France, la 5G (destinée à remplacer la 4G et 3G) devrait être déployée pour tous les utilisateurs d’ici 2020 sur le territoire français. Débits en 5G A l’heure actuelle, il est difficile d’établir la vitesse maximale de la 5G. Son déploiement a été effectué récemment sur la principauté de Monaco, ce […]" />

    <link rel="icon" type="image/png" href="../images/logos/mobilelabs_favicon.png"></link>
  </>
)
